export const OPEN_DRAWER = "drawer/OPEN"
export const CLOSE_DRAWER = "drawer/CLOSE"
export const TOGGLE_DRAWER = "drawer/toggle"